import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type { GetRunResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  isPolling: boolean
  interval?: number
  onSuccess: (data: GetRunResponse) => void
  children?: (data: GetRunResponse) => ReactElement
}

const PollAiRunRequest = ({
  id,
  isPolling,
  interval = 1000,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs/${id}`

  return (
    <AuthenticatedPolling<GetRunResponse>
      children={children}
      intervalMs={interval}
      isPolling={isPolling}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default PollAiRunRequest
